import React from 'react';
import './collaborators.scss';
import { useTranslation } from 'react-i18next';

const Collaborators = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className='containerCollaborators'>
                <div className='titleCollaborators'>
                    <text>{t('collaborators.title')}</text>
                </div>
                <div className='paddingTogether'>
                    <div className='textCollaborators'>
                        {t('collaborators.description')}
                    </div>
                </div>
            </div>
        </>



    );
}

export default Collaborators;
